// libs
import React, { memo } from 'react';

// hooks
import useTheme from '@nykaa/ui-components/themes/hooks/useTheme';

// components
import ProgressBar from 'shared/components/ProgressBar';
import StarRating from 'shared/components/StarRating';

// constants

// styles
import { RatingRow, RatingBarsConatiner, RatingTextLeft, RatingTextRight } from './styles';
// defs
import { IRatingSummary } from 'shared/layouts/DetailsPage/types';

// types
import { Theme } from '@nykaa/ui-components/themes/types';

interface IRatingBarProps {
  ratingSummary: IRatingSummary[];
  isMobile?: boolean;
}

function RatingBars({ ratingSummary, isMobile }: IRatingBarProps) {
  const theme: Theme = useTheme();

  const starSize = isMobile ? '12px' : '20px';

  return (
    <RatingBarsConatiner>
      {ratingSummary.map((rating, i: number) => {
        return (
          <RatingRow key={i}>
            <RatingTextLeft>{rating.star}</RatingTextLeft>

            <StarRating
              activeCount={1}
              maxCount={1}
              size={starSize}
              activeColor={theme?.colors?.textSecondary}
              className="star"
            />

            <ProgressBar
              height={4}
              value={rating.per}
              maxWidth={240}
              backgroundColor={theme?.colors?.surface30}
              foregroundColor={theme?.colors?.textSecondary}
            />
            <RatingTextRight>{rating.count}</RatingTextRight>
          </RatingRow>
        );
      })}
    </RatingBarsConatiner>
  );
}

export default memo(RatingBars);
